<div
  ngbDropdown
  class="app-navbar-item ms-2 ms-lg-4"
  id="kt_header_user_menu_toggle"
>
  <!--begin::Menu wrapper-->
  <div ngbDropdownToggle>
    <ng-content></ng-content>
  </div>
  <!--begin::User account menu-->
  <div
    ngbDropdownMenu
    class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
    data-kt-menu="true"
  >
    <!--begin::Menu item-->
    <div class="menu-item px-3">
      <div class="menu-content d-flex align-items-center px-3">
        <!--begin::Avatar-->
        <div>
        <app-user-avatar-view
          [loaded]="sharedProfileService?.isProfileLoaded"
          [avatar]="sharedProfileService?.currentUser?.avatar"
          [firstLetter]="sharedProfileService?.currentUser?.firstname[0]"
          [customClasses]="'me-2'"
          [size]="50"
          [isCircle]="false"
        ></app-user-avatar-view>
      </div>
        <!--end::Avatar-->
        <!--begin::Username-->
        <div class="d-flex flex-column">
          <div class="fw-bold d-flex align-items-center fs-5">
            {{sharedProfileService.currentUser?.firstname}} {{sharedProfileService.currentUser?.lastname}}
            <!-- <span class="badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2"
              >Pro</span
            > -->
          </div>
          <a class="fw-semibold text-muted text-hover-primary fs-7"
            >{{sharedProfileService.currentUser?.email}}</a
          >
        </div>
        <!--end::Username-->
      </div>
    </div>
    <!--end::Menu item-->
    <!--begin::Menu separator-->
    <div class="separator my-2"></div>
    <!--end::Menu separator-->
    <!--begin::Menu item-->
    <div class="menu-item px-5">
      <a class="menu-link px-5">My Profile</a>
    </div>
    <!--end::Menu item-->
    <!--begin::Menu item-->
    <div class="menu-item px-5">
      <a class="menu-link px-5">
        <span class="menu-text">My Projects</span>
        <span class="menu-badge">
          <span class="badge badge-light-danger badge-circle fw-bold fs-7"
            >3</span
          >
        </span>
      </a>
    </div>
    <!--end::Menu item-->

    <!--begin::Menu item-->
    <div class="menu-item px-5">
      <a class="menu-link px-5">My Statements</a>
    </div>
    <!--end::Menu item-->
    <!--begin::Menu separator-->
    <div class="separator my-2"></div>
    <!--end::Menu separator-->
    <!--begin::Menu item-->
    <div
      class="menu-item px-5"
      data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
      data-kt-menu-placement="left-start"
      data-kt-menu-offset="-15px, 0"
    >
      <a (click)="sharedUiService.toggleThemeMode()" class="menu-link px-5">
        <span class="menu-title position-relative">
          <span class="theme-dark-show">Switch to Light Mode</span>
          <span class="theme-light-show">Switch to Dark Mode</span>

          <span class="ms-5 position-absolute translate-middle-y top-50 end-0">
            <svg-icon
              src="assets/svg/system/light-mode.svg"
              class="svg-icon theme-light-show svg-icon-2"
            >
            </svg-icon>

            <svg-icon
              src="assets/svg/system/dark-mode.svg"
              class="svg-icon theme-dark-show svg-icon-2"
            >
            </svg-icon>
          </span>
        </span>
      </a>
    </div>

    <!--end::Menu item-->

    <!--begin::Menu item-->
    <div
      ngbDropdown
      class="menu-item px-5"
      data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
      data-kt-menu-placement="left-start"
      data-kt-menu-offset="-15px, 0"
    >
      <a ngbDropdownToggle class="menu-link px-5">
        <span class="menu-title position-relative"
          >Language
          <span
            class="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0"
            >{{ sharedUiService.currentActiveLanguage.label }}
            <img
              class="w-15px h-15px rounded-1 ms-2"
              src="assets/media/lang/{{
                sharedUiService.currentActiveLanguage.id
              }}.svg"
              alt="" /></span
        ></span>
      </a>
      <!--begin::Menu sub-->
      <div ngbDropdownMenu class="menu-sub menu-sub-dropdown w-175px py-4">
        <!--begin::Menu item-->
        <div
          *ngFor="let lang of sharedUiService.availableLanguages"
          class="menu-item px-3"
        >
          <a
            (click)="sharedUiService.changeCurrentLanguage(lang.id)"
            class="menu-link d-flex px-5"
            [class.active]="lang.id == sharedUiService.currentActiveLanguage.id"
          >
            <span class="symbol symbol-20px me-4">
              <img
                class="rounded-1"
                src="assets/media/lang/{{ lang.id }}.svg"
                alt=""
              /> </span
            >{{ lang.label }}</a
          >
        </div>
        <!--end::Menu item-->
      </div>
      <!--end::Menu sub-->
    </div>
    <!--end::Menu item-->
    <!--begin::Menu item-->
    <div class="menu-item px-5 my-1">
      <a class="menu-link px-5">Account Settings</a>
    </div>
    <!--end::Menu item-->
    <!--begin::Menu item-->
    <div class="menu-item px-5">
      <a (click)="logout()" class="menu-link px-5">Sign Out</a>
    </div>
    <!--end::Menu item-->
  </div>
  <!--end::User account menu-->
  <!--end::Menu wrapper-->
</div>
